import { useQuery } from '@tanstack/react-query'
import api from '../api'

export const MessageThreads = ({ children, searchParam, unread }) => {
  console.log('searchParam: ', searchParam)
  const req = () => threadsRequest({ searchParam, unread })
  const threads = useQuery('threads', req)
  const { isLoading, isFetching, data } = threads
  console.log('threads: ', threads)
  return children({
    data: data?.data?.data ? data.data.data : {},
    isFetching,
    isLoading,
  })
}

export const workerChatMessagesRequest = (workerId) =>
  api.post('/admin/graphql_dispatch/worker_chat_messages_d8606256', {
    workerId,
  })

export const threadsRequest = ({
  searchParam,
  unread,
  cursor,
  shiftId,
  automated,
  manual,
}) => {
  const variables = {
    searchParam,
    ...(unread && { unread }),
    ...(automated && { automated }),
    ...(manual && { manual }),
    ...(cursor && { cursor }),
    ...(shiftId && { shiftId }),
  }
  return api.post('/admin/graphql_dispatch/threads_79dbc392', variables)
}

export const sendMessage = (user_ids, message, shift_id) => {
  const payload = shift_id
    ? { user_ids, message, shift_id }
    : { user_ids, message }
  return api.post('/admin/user/chat', payload)
}

export const getCallList = (shiftId) =>
  api.get(`/admin/shift/${shiftId}/call_list`)

export const markChatAsRead = (user_ids) =>
  api.post('/admin/user/chat_read', { user_ids })

export const getRecentShiftDescriptions = () =>
  api.get('/admin/messages_shift_descriptions')
